module.exports = __webpack_public_path__ + "static/media/YF97_7.0bb089df.jpg";